import { datadogLogs } from '@datadog/browser-logs'
import React, { useState } from 'react'
import useSurveyResult from '../../../../apollo/localState/useSurveyResult'
import { ProjectMetadata } from '../../../../data/model/results'
import { downloadXlsxFile } from '../../../../utils/chartUtils'
import { downloadPptxFile } from '../../../../utils/pptxUtils'
import DialogExportToPowerPoint from '../../../Results/DialogExportToPowerPoint/DialogExportToPowerPoint'
import PublicResultsOptionsControl from './PublicResultsOptions.control'

interface Props {
  isMultiMarket: boolean
  disableShowQuotas: boolean
  projectMetadata: ProjectMetadata
  setShowQuotas: (show: boolean) => void
}

const PublicResultsOptionsContainer: React.FC<Props> = ({
  isMultiMarket,
  disableShowQuotas,
  projectMetadata,
  setShowQuotas
}: Props) => {
  const [isExportToPptxDialogOpen, setIsExportToPptxDialogOpen] =
    useState<boolean>(false)
  const { readSurveyResult } = useSurveyResult()

  const handleDownloadChartData = (): void => {
    const surveyResult = readSurveyResult()

    if (!surveyResult.length) {
      return
    }

    downloadXlsxFile({
      data: surveyResult,
      fileName: `${projectMetadata.projectName}.xlsx`
    })
  }

  const openExportToPptxDialog = (): void => {
    setIsExportToPptxDialogOpen(true)
  }

  const handleExportToPptx = (): void => {
    const surveyResult = readSurveyResult()

    if (!surveyResult.length) {
      return
    }

    void downloadPptxFile(
      surveyResult,
      projectMetadata.fieldwork,
      projectMetadata.projectName
    ).catch((error) => {
      datadogLogs.logger.error(
        `Export to PowerPoint failed for public dashboard: ${projectMetadata.projectName}`,
        { error }
      )
    })

    setIsExportToPptxDialogOpen(false)
  }

  return (
    <>
      <PublicResultsOptionsControl
        isMultiMarket={isMultiMarket}
        disableShowQuotas={disableShowQuotas}
        onShowQuotasChange={setShowQuotas}
        onClickChartData={handleDownloadChartData}
        onClickExportToPptx={openExportToPptxDialog}
      />
      <DialogExportToPowerPoint
        isDialogOpen={isExportToPptxDialogOpen}
        onExportToPptx={handleExportToPptx}
        onClose={() => setIsExportToPptxDialogOpen(false)}
      />
    </>
  )
}

export default PublicResultsOptionsContainer
